import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

// Warms the PDF cache when the email drawer is opened so it is ready
// by the time the user clicks "Save as PDF".
export default class extends Controller {
  static values = { url: String }

  connect() {
    this._toggleHandler = (e) => this.onToggle(e)
    this.element.addEventListener("toggle", this._toggleHandler)
  }

  disconnect() {
    this.element.removeEventListener("toggle", this._toggleHandler)
  }

  async onToggle(e) {
    if (e.newState !== "open") return
    await post(this.urlValue)
  }
}
